import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        columnId: PropTypes.string,
    };

    listView(list = [], columnId) {
        const idReg = new RegExp(`/${columnId}/`, 'ig');

        return list.map((item, index) => {
            const isThis = idReg.test(item.url);

            return (
                <a
                    key={index}
                    className={isThis ? styles.active : null}
                    style={index === 0 ? null : { marginLeft: '3px' }}
                    href={formatUrl(item.url)}>
                    {item.title}
                </a>
            );
        });
    }
    render() {
        const { content, columnId } = this.props;

        return <div className={classNames(styles.nav, 'clearfix')}>{this.listView(content, columnId)}</div>;
    }
}

export default Nav;
